module.exports = __webpack_public_path__ + "img/qizhi_blue.19551010.png";